import JSZip from 'jszip'
export const archive = () => new JSZip()
export const file = (zip,name,content,opts) => {zip.file(name,content,opts);return zip}
export const folder = (zip,name)=>zip.folder(name)
export const blob = (zip)=>zip.generateAsync({type:"blob"})